// One video at a time, app-wide.
//
// The community feed already coordinates its own players (feedAutoplay /
// isFeedActive), but nothing did outside it: the course pages mount an
// autoplaying player per module and per video-pillola, and Ionic keeps the
// pages you navigated away from alive in the DOM. Starting a second video
// therefore left the first one running and you heard both at once.
//
// This is deliberately a tiny module-level registry rather than React state or
// context: the players that must silence each other live on DIFFERENT Ionic
// pages, so they share no provider, and the check has to be synchronous at the
// moment playback starts.

/** @type {{ id: number, pause: () => void } | null} */
let active = null;

let nextId = 1;

/** A stable id for one player instance (props can repeat across pages). */
export const nextVideoPlaybackId = () => nextId++;

/**
 * Declare that this player just started playing, and stop whoever was before.
 *
 * The previous holder's pause callback is expected to also suppress its own
 * auto-restart — otherwise a still-on-screen autoplaying player would
 * immediately resume and the two would fight.
 */
export const claimVideoPlayback = (id, pause) => {
  if (active && active.id !== id) {
    try {
      active.pause();
    } catch {
      /* a dead player must never block the new one from playing */
    }
  }

  active = { id, pause };
};

/** Give up the slot — on pause, on end, or on unmount. */
export const releaseVideoPlayback = (id) => {
  if (active && active.id === id) active = null;
};
